/**
 * One narration — the agent thinking out loud mid-turn ("I'm sizing that cohort against site
 * NTS now…"). It reads as the agent talking, not as chrome: the same bubble treatment as the
 * reply text, in the same place in the sequence, with no marker of its own. Always shown,
 * never behind the tool-call toggle.
 */
export function NarrationBubble({ text }: { text: string }) {
  return (
    <div className="bg-card border-border max-w-[85%] rounded-2xl border px-4 py-2.5 text-sm leading-relaxed">
      <p className="whitespace-pre-wrap">{text}</p>
    </div>
  );
}
